import React, { useEffect } from "react";
import { runtimeConfig } from "../../config/runtimeConfig";

/**
 * Legacy consumer-SPA /studio/advertising* entry — Advertising lives in Blade Admin.
 * Redirects to adminBaseUrl + advertising… so subscribers never see admin UI.
 */
function AdvertisingAdminRedirect({ location }) {
  const path = (location && location.pathname) || "/studio/advertising";
  const search = (location && location.search) || "";
  // Map /studio/advertising → advertising, /studio/advertising/analytics → advertising/analytics
  let suffix = path.replace(/^\//, "");
  if (suffix.indexOf("studio/advertising") === 0) {
    suffix = "advertising" + suffix.slice("studio/advertising".length);
  } else if (suffix.indexOf("advertising") !== 0) {
    suffix = "advertising";
  }
  const target =
    String(runtimeConfig.adminBaseUrl || "").replace(/\/+$/, "/") +
    suffix +
    search;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div
      className="main-sec-content"
      style={{ padding: "3rem 1.5rem", maxWidth: "36rem" }}
      role="status"
    >
      <h1 style={{ fontSize: "1.35rem", marginBottom: "0.75rem" }}>
        Advertising moved to Administrator
      </h1>
      <p style={{ marginBottom: "1rem" }}>
        Campaign and placement management is in the Admin Dashboard, not the
        subscriber site. Redirecting…
      </p>
      <p>
        <a href={target}>Open Admin Advertising</a>
        {" · "}
        <a href="/home">Return to Home</a>
      </p>
    </div>
  );
}

export default AdvertisingAdminRedirect;
